<template>
    <div class="contactsubmit">
        <div class="verif-wrapper">
        <b-alert :variant="alert.variant" :show="alert.visible" class="d-flex flex-wrap-0 align-items-center justify-content-start pt-3 pb-2 mb-5">
        <div class="flex-grow-0 pl-0 pr-4">
            <b-icon :icon="alert.icon" :variant="alert.variant" class="left-alert-icon" />
        </div>
        <div class="flex-grow-1 mb-1"><span v-html="alert.text"></span><span v-if="alert.retryLink"><br/><a class="cursor-pointer" @click="states.mainPage=false">Zmeniť údaje na overenie</a></span></div>
        </b-alert>
        <h2 class="mt-5" v-text="heading" />
        <div class="form-group position-relative my-5">
        <label class="inner-label">Telefónne číslo</label>
        <input type="text" class="form-control" :class="{ 'res_error': errors.mobilePhone.visible }" v-model="newData.mobilePhone" @keyup="checkChange('mobilePhone')" :disabled="disabled.mobilePhone || submitDisabled">
        <span class="error_message text-muted position-absolute" v-show="errors.mobilePhone.visible"><small v-text="errors.mobilePhone.text" /></span>
        </div>
        <div class="form-group position-relative my-5">
        <label class="inner-label">E-mail</label>
        <input type="text" class="form-control" :class="{ 'res_error': errors.email.visible }" v-model="newData.email" @keyup="checkChange('email')" :disabled="disabled.email || submitDisabled">
        <span class="error_message text-muted position-absolute" v-show="errors.email.visible"><small v-text="errors.email.text" /></span>        
        </div>
        <p class="mt-5 mb-3"><a href="/wiki/ostatne/osobne-udaje" target="disc" class="font-weight-bold">Informácie o spracúvaní vašich osobných údajov</a></p>
        <b-button variant="primary" size="lg" :disabled="submitDisabled" block class="text-uppercase" @click="sendData"><span v-html="sendText" /></b-button>
    </div>
    </div>    
</template>
<script>
import { checkMailVal, validateMsisdn } from '@/components/common'
export default {
  name: 'ResidSubmit',
  props: ['states', 'submitData'],
  components: {},
    data() {
        return {
            submitDisabled: false,
            heading: 'Údaje, ktoré je možné upraviť:',
            hasChange: false,
            errors: { mobilePhone: { visible: false, text: 'Telefónne číslo nie je správne vyplnené' }, email: { visible: false, text: 'E-mail nie je správne vyplnený' }},
            newData: { mobilePhone: this.submitData.mobilePhone, email: this.submitData.email },
            disabled: { mobilePhone: false, email: false },
            alert: { variant: 'success', visible: false, icon: 'check-circle-fill', text: 'Požiadavka na zmenu Vašich údajov prebehla úspešne.', retryLink: false }
        }
    },  
    created: function() {
    },
    mounted() { 
        if (this.submitData.hasBoth) {
            this.disabled.mobilePhone = this.submitData.otpType === 'email';
            this.disabled.email = this.submitData.otpType === 'msisdn';
            this.heading = this.submitData.otpType === 'email' ? 'E-mail je možné upraviť:' : 'Telefónne číslo je možné upraviť:'
        } else {
            this.heading = 'Údaje, ktoré je možné upraviť:';
        }
    },
    computed: { 
        sendText : function() {
            if (this.submitData.mobilePhone !== this.newData.mobilePhone || this.submitData.email !== this.newData.email) {
                this.hasChange = true;
                return 'Uložiť zmeny'
            } else {
                this.hasChange = false;
                return 'Údaje sú správne'
            }
        }
    }, 
    methods: {
        sendData() {
            this.errors.mobilePhone.visible = false;
            this.errors.email.visible = false;
            this.alert.visible = false;
            this.alert.retryLink = false;
            var formOk = true; 
            if (!validateMsisdn(this.newData.mobilePhone)) {
                this.errors.mobilePhone.visible = true;
                formOk = false;
            }
            if (!checkMailVal(this.newData.email)) {
                this.errors.email.visible = true;
                formOk = false;
            }
            if (formOk) {
                this.submitDisabled = true;
                const payload = { identData: this.submitData, newData: this.newData, hasChange: this.hasChange }
                var that = this;
                this.$store.commit('setSpinnerState', true);
                this.$http.post(that.$store.state.validateCustSrc + "/submit", payload).then(function(resp){
                    var text = that.hasChange ? 'Požiadavka na zmenu Vašich údajov prebehla úspešne.' : 'Ďakujeme za potvrdenie správnosti Vašich kontaktných údajov.';
                    that.alert = { variant: 'success', visible: true, icon: 'check-circle-fill', text, retryLink: true }
                }).catch(function(err){
                    var TYText = "Požiadavka na uloženie zlyhala.";
                    var retryLink = false;
                    switch((err.response || {}).status) {
                        case 400:
                        TYText = "Niektorý z údajov nemá platný formát."
                        break;
                        case 403:
                        retryLink = true;
                        TYText = "Overenie exspirovalo."
                        break;
                        default:
                        TYText = "Požiadavka na uloženie zlyhala."
                    } 
                    that.alert = { visible: true, text: TYText, variant: 'warning', icon: 'exclamation-circle-fill', retryLink } 
                    that.submitDisabled = false;
                }).finally(function(){
                    that.$store.commit('setSpinnerState', false);
                })
            }
        },
        checkChange(channel) {
            this.errors[channel].visible = false;
        }
    }        
}
</script>
<style scoped>
button.btn.btn-primary span {
    color: #ffffff !important;
    font-size: 18px;
}
</style>